import React, { useState } from "react";
import "./index.css";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import googleCalendarPlugin from "@fullcalendar/google-calendar";
import interactionPlugin from "@fullcalendar/interaction";
import { useEffect } from "react";
import { Button, Card, Form, Input, Modal } from "antd";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormHelperText,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ErrorIcon from "@mui/icons-material/Error";
import dayjs from "dayjs";
import { fetchRoleData } from "../../redux/slice/getRoleData";
import { useDispatch, useSelector } from "react-redux";
import env from "../../config/env";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import { Navigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import LeaveStyle from "../../Components/LeavesStyle";
import EditIcon from "@mui/icons-material/Edit";
import { Tag, Typography as typography_antd } from "antd";
import moment from "moment";
const { Title } = typography_antd;
const { Option } = Select;
// import hrmsServices from "../services/hrms.services";

const Holidays = (props) => {
  const [open, setOpen] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [showModal, setShowModal] = useState();
  const [showModalData, setShowModalData] = useState({
    title: "",
    date: "",
  });
  const [conformDialog, setConformDialog] = useState(false);
  const [arr, setArr] = useState([]);
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState("");
  const [tempDate, setTempDate] = useState("");
  const [currentValue, setCurrentValue] = useState("");
  const [roleData, setRoleData] = useState();
  const [form] = Form.useForm();
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [newArray, setNewArray] = useState([]);
  const [formData, setFormData] = useState({
    holiday_title: "",
    role: [],
  });
  const [helperTxt, setHelperTxt] = useState("");
  const [helperTxtselect, setHelperTxtselect] = useState("");

  const now = new Date();
  const currentYear = now.getFullYear();
  const isLastMonth = now.getMonth() === 11; // December (0-based)
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const maxYear = isLastMonth ? currentYear + 1 : currentYear;

  const years = Array.from(
    { length: maxYear - 2000 + 1 },
    (_, index) => maxYear - index
  );

  const allRoleIds = roleData?.map((r) => r.id) || [];

  const isAllSelected =
    roleData?.length > 0 && selectedRoles.length === roleData.length;

  const checkIsAllSelected =
    roleData?.length > 0 && currentValue?.role?.length === roleData.length;

  const ITEM_HEIGHT = 40;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      sx: {
        "& .MuiMenuItem-root": {
          maxHeight: "40px"
        },
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const token = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.auth.userData)
  const state = useSelector((state) => state);
  const temp = state?.getRoleData.data?.data;
  const dispatch = useDispatch();
  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  // if (state?.getRoleData?.data?.status === 555 || state?.getRoleData?.data?.status === 501) {
  //   dispatch(setToken(null));
  //   dispatch(setUserData(null));
  // toast.error("Session expire, Please LogIn!", {
  //   position: toast.POSITION.TOP_RIGHT,
  //   toastId: "1",
  // });
  // }

  useEffect(() => {
    fetchData();
  }, [selectedYear]);

  useEffect(() => {
    dispatch(fetchRoleData(token));
  }, [token]);

  useEffect(() => {
    setRoleData(temp);
  }, [temp]);

  useEffect(() => {
    // const updatedEvents = JSON.parse(localStorage.getItem("updatedEvents"));

    // if (updatedEvents) {
    //   setArr(updatedEvents);
    // }
    fetchData();
  }, [props?.role]);

  const fetchData = async () => {
    const currentUserRole = props?.role;
    if (currentUserRole) {
      let newArr = [];

      try {
        setLoading(false);
        let url;

        const getHoliday = CryptoJS.SHA256("/getHoliday" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

        // if (currentUserRole === 3) {
        url = `${env.backend_api_endpoint}/${getHoliday}`;
        // } 
        // else {
        //   url = `${env.backend_api_endpoint}/getHoliday?roleId=${currentUserRole}`;
        // }
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          if (errorData.status === 404) {
          }
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            // Navigate("/login")
          }
        }

        if (response.ok) {

          const successData = await response.json();

          if (successData.status === 200 && successData.encryptedData) {

            // Decrypt backend response
            const bytes = CryptoJS.AES.decrypt(successData.encryptedData, SECRET_KEY);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

            console.log(decryptedData, "vhvhgvh")

            // const currentYear = new Date().getFullYear();

            if (userData.role_id == 3) {

              // Map → Filter current year → Sort ascending
              const holidayArr = decryptedData
                .map((doc) => ({
                  holy_id: doc.id,
                  title: doc.holiday_title,
                  date: doc.holiday_date,
                  role: doc.role,
                  color: "rgb(36, 77, 160)",
                }))
                .filter((item) => new Date(item.date).getFullYear() === selectedYear)
                .sort((a, b) => new Date(a.date) - new Date(b.date));

              setNewArray(holidayArr);
              setLoading(false);
            }
            else {
              decryptedData?.map((doc) => {
                newArr.push({
                  holy_id: doc.id,
                  title: doc.holiday_title,
                  date: doc.holiday_date,
                  role: doc.role,
                  color: "rgb(36, 77, 160)",
                });
              })
              // .filter((item) => new Date(item.date).getFullYear() === currentYear)
              //   .sort((a, b) => new Date(a.date) - new Date(b.date));;

              setNewArray(newArr);
              setLoading(false);
            }
          }
        }
      } catch (error) {
        console.error("Error Roles in:", error.message);
      }

      let userDataArr = [];

      if (userData?.role_id !== 3) {
        try {
          setLoading(true);

          const getEmployee = CryptoJS.SHA256("/getEmployee" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

          const response = await fetch(
            `${env.backend_api_endpoint}/${getEmployee}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                authorization: token,
              },
            }
          );
          if (!response.ok) {
            const errorData = await response.json();
            if (errorData.status === 404) {
            }
            if (errorData.status === 555 || errorData.status === 501) {
              dispatch(setToken(null));
              dispatch(setUserData(null));
              toast.error("Session expire, Please LogIn!", {
                position: toast.POSITION.TOP_RIGHT,
                toastId: "1",
              });
              // Navigate("/login")
            }
          }
          if (response.ok) {
            const successData = await response.json();

            if (successData.status === 200 && successData.data) {

              const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
              const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

              decryptedData?.map((item) => {
                const userDob = item.dob;
                const currentDate = new Date();
                const currentYear = currentDate.getFullYear();

                const modifiedDob = `${currentYear}-${userDob?.substr(5)}`;
                userDataArr.push({
                  title: `${item.name}'s Birthday`,
                  date: modifiedDob,
                  color: "rgb(26,171,142)",
                });
              });
            }
          }
        } catch (error) {
          console.error("Error User in:", error.message);
        }
        // // Filter only current year data
        // const currentYear = new Date().getFullYear();

        // const filteredHoliday = newArr.filter(item =>
        //   new Date(item.date).getFullYear() === currentYear
        // );

        // const filteredBirthdays = userDataArr.filter(item =>
        //   new Date(item.date).getFullYear() === currentYear
        // );

        // const mergedArray = filteredHoliday.concat(filteredBirthdays).sort((a, b) => new Date(a.date) - new Date(b.date));;

        // setNewArray(mergedArray);

        const mergedArray = newArr.concat(userDataArr);
        setNewArray(mergedArray);
        setLoading(false);
      }

    }
  };

  const handleClose = () => {
    setDate("");
    setOpen(false);
    setSelectedRoles([]);
    setFormData({
      holiday_title: "",
      role: [],
    });
    setHelperTxt("");
    setHelperTxtselect("");
    form.resetFields();
  };

  const handleClick = (e) => {
    setDate(e.dateStr);
    setOpen(true);
  };

  const handleConform = () => {
    setConformDialog(true);
  };

  const handleSave = async () => {
    if (formData.holiday_title !== "" && formData.role.length !== 0) {
      let obj = {
        holiday_title: formData.holiday_title,
        holiday_date: date,
        role: formData.role,
      };
      try {

        const data = {
          date: date,
          title: formData.holiday_title,
          role: formData.role,
        }

        //encrypt data
        const encryptData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();

        //encrypt endpoint
        const addHoliday = CryptoJS.SHA256("/addHoliday" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const response = await fetch(`${env.backend_api_endpoint}/${addHoliday}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedData: encryptData }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          if (errorData?.status === 400) {
            if (errorData?.message === "Title is required") {
              setHelperTxt("Please Enter The Title");
            }
            if (errorData?.message === "Role is required") {
              setHelperTxtselect("Please Select The Role");
            }
          }
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            // Navigate("/login")
          }
        }
        if (response.ok) {
          const successData = await response.json();
          if (successData.status === 200) {
            toast.success("Event Add Successfully !", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            setDate("");
            setOpen(false);
            setHelperTxt("");
            setHelperTxtselect("");
            setFormData({
              holiday_title: "",
              role: [],
            });
            setSelectedRoles([]);
            fetchData();
          }
        }
      } catch (error) {
        console.error("Error Add Holiday in:", error.message);
      }
    }
    if (formData.holiday_title === "") {
      setHelperTxt("Please Enter The Title");
    }
    if (formData.role.length === 0) {
      setHelperTxtselect("Please Select The Role");
    }
  };

  // const handleEventUpdate = (e) => {
  //   setUpdateDialog(true);
  //   setCurrentValue({
  //     holy_id: e.event._def.extendedProps?.holy_id,
  //     holiday_title: e.event.title,
  //     holiday_date: e.event.startStr,
  //     role: e.event._def.extendedProps?.role ?? [],
  //   });

  // };

  const handleEventUpdate = (item) => {
    setUpdateDialog(true);

    setCurrentValue({
      holy_id: item.holy_id,
      holiday_title: item.title,
      holiday_date: item.date,
      role: item.role ?? [],
    });
  };

  const cancelDialog = () => {
    setUpdateDialog(false);
    setCurrentValue({
      holy_id: "",
      holiday_title: "",
      holiday_date: "",
      role: [],
    });
    setHelperTxt("");
    setHelperTxtselect("");
  };

  const handleConformClose = () => {
    setConformDialog(false);
  };

  const onSave = async () => {
    if (currentValue.holiday_title !== "" && currentValue.role.length !== 0) {
      try {

        const data = {
          holidayId: currentValue?.holy_id,
          date: currentValue?.holiday_date,
          title: currentValue.holiday_title,
          role: currentValue.role,
        }

        //encrypt data
        const encryptData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();

        //encrypt endpoint
        const updateHoliday = CryptoJS.SHA256("/updateHoliday" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const response = await fetch(`${env.backend_api_endpoint}/${updateHoliday}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
            body: JSON.stringify({ encryptedData: encryptData }),

          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          if (errorData?.status === 400) {
          }
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            // Navigate("/login")

          }
        }
        if (response.ok) {
          const successData = await response.json();
          if (successData.status === 200) {
            const updatedArr = arr.map((event) => {
              if (event.holy_id === currentValue.holy_id) {
                return {
                  holy_id: event.holy_id,
                  date: date,
                  title: currentValue.holiday_title,
                  role: currentValue.role,
                };
              } else {
                return event;
              }
            });
            const index = newArray.findIndex(
              (item) => item.holy_id === currentValue.holy_id
            );
            const updatedEventsArray = [...newArray];
            updatedEventsArray[index] = {
              ...updatedEventsArray[index],
              ...currentValue,
              title: currentValue.holiday_title,
              date: currentValue.holiday_date,
            };
            // setArr(updatedArr);
            setNewArray(updatedEventsArray);

            setCurrentValue({
              holy_id: "",
              holiday_title: "",
              holiday_date: "",
              role: [],
            });
            setSelectedRoles([]);
            // localStorage.setItem("updatedEvents", JSON.stringify(updatedArr));
            setUpdateDialog(false);
            toast.success("Event Updated Successfully !", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            fetchData();
          }
        }
      } catch (error) {
        console.error("Error Add Holiday in:", error.message);
      }
    }
    if (currentValue.holiday_title === "") {
      setHelperTxt("Please Enter The Title");
    }
    if (currentValue.role.length === 0) {
      setHelperTxtselect("Please Select The Role");
    }
    if (currentValue.holiday_date === "") {
      setHelperTxtselect("Please Select The Date");
    }
  };


  const deleteEvent = async () => {
    try {

      const data = { holidayId: currentValue?.holy_id, }

      console.log(currentValue.holy_id, "hgjhgh")

      const deleteHoliday = CryptoJS.SHA256("/deleteHoliday" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      //encrypt data
      const encryptData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();

      const response = await fetch(
        `${env.backend_api_endpoint}/${deleteHoliday}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedData: encryptData }),
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData?.status === 400) {
        }
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          // Navigate("/login")
        }
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200) {
          const updatedArr = newArray?.filter(
            (event) => event.holy_id !== currentValue.holy_id
          );
          // console.log(updatedArr,"updated")
          setNewArray(updatedArr);
          setUpdateDialog(false);
          setCurrentValue({
            holy_id: "",
            holiday_title: "",
            holiday_date: "",
            role: [],
          });

          setConformDialog(false);

          setUpdateDialog(false);
          toast.success("Event Deleted Successfully !", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });

          fetchData();
        }
      }
    } catch (error) {
      console.error("Error Add Holiday in:", error.message);
    }
  };

  // const handleRoleSelect = (event) => {
  //   const {
  //     target: { value },
  //   } = event;

  //   // Select All clicked
  //   if (value.includes("all")) {
  //     const newValue = isAllSelected ? [] : allRoleIds;

  //     setSelectedRoles(newValue);
  //     setFormData({ ...formData, role: newValue });
  //     setHelperTxtselect(newValue.length === 0 ? "Please Select Role!" : "");
  //     return;
  //   }

  //   setSelectedRoles(value);
  //   setFormData({ ...formData, role: value });
  //   setHelperTxtselect(value.length === 0 ? "Please Select Role!" : "");
  // };

  const handleRoleSelect = (selectedValues) => {
    const {
      target: { value },
    } = selectedValues;

    // 🔹 ONLY ADD THIS BLOCK
    if (value.includes("all")) {
      const newValue = isAllSelected ? [] : allRoleIds;

      setSelectedRoles(newValue);
      setFormData({ ...formData, role: newValue });
      setHelperTxtselect(newValue.length === 0 ? "Please Select Role!" : "");
      return true;
    }
    // 🔹 END ADDITION

    setSelectedRoles(typeof value === "string" ? value.split(",") : value);
    setFormData({ ...formData, role: value });
    if (Object.keys(selectedValues).length === 0) {
      setHelperTxtselect("Please Select Role!");
    } else {
      setHelperTxtselect("");
    }
    return true;
  };

  const handleUpdateSelect = (selecteValue) => {
    const {
      target: { value },
    } = selecteValue;

    // 🔹 ADD ONLY THIS BLOCK
    if (value.includes("all")) {
      const newValue = checkIsAllSelected ? [] : allRoleIds;

      setSelectedRoles(newValue);
      setCurrentValue({ ...currentValue, role: newValue });
      setHelperTxtselect(newValue.length === 0 ? "Please Select Role!" : "");
      return true;
    }
    // 🔹 END ADDITION

    setSelectedRoles(typeof value === "string" ? value.split(",") : value);
    setCurrentValue({ ...currentValue, role: value });
    if (Object.keys(selecteValue).length === 0) {
      setHelperTxtselect("Please Select Role!");
    } else {
      setHelperTxtselect("");
    }
    return true;
  };

  const handleEventClick = (e) => {
    const currentUserRole = props?.role;
    setDate(e.event.startStr);
    setTempDate(e.event.startStr);
    // if (currentUserRole === 3) {
    //   let found = false;
    //   for (const newArra of newArray) {
    //     if (newArra.title === e.event.title) {
    //       found = true;
    //       break;
    //     }
    //   }

    //   if (found) {
    //     handleEventUpdate(e);
    //   } else {
    //     setShowModal(true);
    //     setShowModalData({
    //       title: e.event.title,
    //       date: dayjs(e.event.startStr).format("DD-MM-YYYY"),
    //     });
    //     // setShowModalData(e.event.title);
    //   }
    // } else {
    setShowModal(true);
    // setShowModalData(e.event.title);
    setShowModalData({
      title: e.event.title,
      date: dayjs(e.event.startStr).format("DD-MM-YYYY"),
    });
    // }
  };

  const handleEvent = (item) => {
    setShowModal(true);  // <-- VIEW MODE modal only
    setShowModalData({
      title: item.title,
      date: dayjs(item.date).format("DD-MM-YYYY"),
      role: item.role ?? [],
    });
  };

  return (
    <div className="container">
      {(userData.role_id == 1 || userData.role_id == 4) && (
        <Card
          bodyStyle={{ height: "calc(100vh - 75px)", overflow: "auto", padding: "10px" }}
          bordered={false}
          style={{
            margin: 10,
          }}
        >
          {loading === false ? (
            <FullCalendar
              eventColor="blue"
              plugins={[dayGridPlugin, googleCalendarPlugin, interactionPlugin]}
              events={newArray}
              selectable={true}
              // dateClick={(e) =>
              //   props?.role === 3 ? handleClick(e) : console.log(e)
              // }
              eventClick={handleEventClick}
              eventDisplay="true"
            />
          ) : (
            <Card
              style={{
                height: "85vh",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <span class="loader"></span>
            </Card>
          )}
        </Card>
      )}

      {userData.role_id == 3 &&
        <LeaveStyle>
          <div className="site-card-border-less-wrapper" >
            <Card
              bodyStyle={{ height: "calc(100vh - 100px)", padding: "10px" }}
              bordered={false}
              style={{
                margin: 10,
                padding: 10,
              }}
            >
              <div className="AllEmployeeHeaderWrapper" style={{ paddingTop: "0px" }}>
                <div className="AllEmployeeHeader">
                  <div className="HeaderTitle ">
                    <Title
                      level={2}
                      style={{
                        color: "#244DA0",
                        fontFamily: "ImportedMilliardBold",
                        fontWeight: 500,
                        marginBottom: "0px",
                      }}
                    >
                      Spectus Holidays
                    </Title>

                    <div className="iconplus">
                      <AddCircleOutlineIcon />
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "10px" }}>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="year-select-label">Select Year</InputLabel>
                      <Select
                        labelId="year-select-label"
                        value={selectedYear}
                        label="Select Year"
                        size="small"
                        onChange={(e) => setSelectedYear(e.target.value)}
                      >
                        {years.map((yr) => (
                          <MenuItem key={yr} value={yr} sx={{ fontFamily: "MilliardBook, sans-serif" }}>
                            {yr}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>


                    {/* <div className="btn-flex"> */}
                    <div>
                      <Button
                        size="large"
                        variant="contained"
                        htmlType="submit"
                        onClick={handleClick}
                        style={{
                          backgroundColor: "#244DA0",
                          borderRadius: "6px",
                          color: "white",
                          fontWeight: "500",
                          borderColor: "#244DA0",
                          textTransform: "none",
                          fontFamily: "MilliardMedium"
                          // height: "44px",
                        }}
                      >
                        Add Holiday
                      </Button>
                    </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>


              <div
                style={{
                  overflowX: 'auto', // for horizontal scroll if needed
                  width: '100%',
                }}
                className="All_employee_table"
              >
                {loading === false ? (

                  < TableContainer component={Paper} className="table-container"
                    style={{
                      maxHeight: 'calc(100vh - 170px)',
                      overflowY: 'auto',
                      width: '100%',
                      borderTopLeftRadius: 15,
                      borderTopRightRadius: 15,
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0
                    }}>
                    <Table
                      sx={{
                        minWidth: 650,
                        '& th, & td': {
                          border: '1px solid #f0f0f0',
                        },
                      }}
                      aria-label="simple table"
                    >
                      <TableHead
                        // displaySelectAll={true}
                        className="table_Header_color"
                        sx={{ height: "50px" }}
                      >
                        <TableRow
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            backgroundColor: "#244DA0",

                          }}
                        >
                          <TableCell style={{ color: "white", width: "100px" }}>
                            Sr No.
                          </TableCell>
                          <TableCell style={{ color: "white", }}>
                            Holiday Name
                          </TableCell>

                          <TableCell style={{ color: "white", }}>
                            Date
                          </TableCell>

                          {/* <TableCell style={{ color: "white" }}>
                            Description
                          </TableCell>

                          <TableCell style={{ color: "white" }}>
                            Role
                          </TableCell> */}

                          <TableCell style={{ color: "white", width: "120px" }}>
                            Action
                          </TableCell>

                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {newArray.length > 0 ? (
                          newArray.map((val, index) => (

                            <TableRow
                              onClick={() => handleEvent(val)}
                              // key={row?.name}
                              sx={{
                                cursor: "pointer"
                              }}
                            >
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{val.title}</TableCell>
                              <TableCell >{moment(val.date).format("DD-MM-YYYY")}</TableCell>
                              {/* <TableCell></TableCell>
                            <TableCell>{val.role}</TableCell> */}
                              <TableCell onClick={(e) => e.stopPropagation()}   >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-around",
                                  }}
                                >
                                  <Tooltip title="Edit">
                                    <EditIcon
                                      onClick={(e) => {
                                        console.log("EDIT ITEM:", val);
                                        e.stopPropagation();
                                        handleEventUpdate(val);
                                      }}
                                      style={{
                                        color: "green",
                                        border: "none",
                                        fontSize: "19px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Delete">
                                    <DeleteIcon
                                      onClick={(e) => {
                                        e.stopPropagation(); // Stop TableRow's onClick
                                        setCurrentValue(val)
                                        handleConform();
                                      }}
                                      style={{
                                        color: "red",
                                        border: "none",
                                        fontSize: "19px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </Tooltip>
                                </div>
                              </TableCell>

                            </TableRow>
                          ))) : (
                          <TableRow>
                            <TableCell colSpan={6} align="center">
                              No records found.
                            </TableCell>
                          </TableRow>
                        )}


                      </TableBody>
                    </Table>
                  </TableContainer>

                ) : (
                  <span class="loader"></span>
                )}
              </div>
            </Card>
          </div>
        </LeaveStyle >
      }

      {/* Add Event Modal */}
      <Dialog
        id="Add_event_dialog"
        open={open}
        onClose={false}
        className="filter_model"
        sx={{
          // "& *": {
          //   fontFamily: "Milliard, sans-serif",
          // },

          "& .MuiInputBase-root, & .MuiInputLabel-root, & .MuiFormHelperText-root": {
            fontFamily: "Milliard, sans-serif",
          },
        }}
      >
        <DialogTitle id="dialog_title">Add Event</DialogTitle>
        <Divider />
        <DialogContent
          sx={{ m: 1, width: 300, display: "flex", flexDirection: "column" }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            className="Add_event_dialog_date_picker"
          >
            <DatePicker
              defaultValue={date ? dayjs(date) : null}
              fullWidth
              format="DD-MM-YYYY"
              onChange={(e) => {
                setDate(e.format("YYYY-MM-DD"));
              }}
              slotProps={{
                textField: {
                  size: "small",
                  // sx: {
                  //   "& .MuiInputBase-root": {
                  //     height: 40, // same as FormControl size="small"
                  //   },
                  // },
                },
              }}
            // error={errorText.dob}
            />
          </LocalizationProvider>

          <FormControl id="Event_role" size="small">
            <InputLabel id="demo-multiple-name-label">Select Role</InputLabel>
            <Select
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              variant="outlined"
              multiple
              value={selectedRoles}
              onChange={handleRoleSelect}
              input={<OutlinedInput label="Select Role" />}
              MenuProps={MenuProps}
              style={{ marginBottom: "0px", marginTop: "15px", fontFamily: "MilliardBook, sans-serif" }}
              error={helperTxtselect === "" ? false : true}
              helperText={helperTxtselect}
              renderValue={(selected) => {
                let mtch = roleData?.filter((x) => selected.indexOf(x.id) > -1);
                if (mtch) {
                  mtch = mtch.map((x) => x.value).join(", ");
                  return mtch;
                }
                return;
              }}
            >
              <MenuItem value="all" sx={{ fontFamily: "MilliardBook, sans-serif" }}>
                <Checkbox
                  checked={isAllSelected}
                  indeterminate={
                    selectedRoles.length > 0 &&
                    selectedRoles.length < roleData?.length
                  }
                />
                Select All
              </MenuItem>

              {roleData &&
                roleData.map((role) => (
                  <MenuItem key={role.id} value={role.id} sx={{ fontFamily: "MilliardBook, sans-serif" }}>
                    <Checkbox checked={selectedRoles.indexOf(role.id) > -1} />
                    {role.value}
                  </MenuItem>
                ))}
            </Select>
            <FormHelperText style={{ color: "#d32f2f" }}>
              {helperTxtselect}
            </FormHelperText>
          </FormControl>
          <TextField
            size="small"
            margin="dense"
            id="title"
            label="Add Title"
            type="text"
            fullWidth
            variant="outlined"
            error={helperTxt === "" ? false : true}
            helperText={helperTxt}
            style={{ marginTop: "12px" }}
            onChange={(e) => {
              setFormData({ ...formData, holiday_title: e.target.value });
              if (e.target.value === "") {
                setHelperTxt("Please input Title!");
              } else {
                setHelperTxt("");
              }
              return true;
            }}
          />
        </DialogContent>
        <Divider />
        <DialogActions
          style={{ justifyContent: "space-around", margin: "0px" }}
        >
          <div className="button-container" onClick={handleClose}>
            <Button
              block
              size="large"
              style={{
                color: "red",
                fontWeight: "600",
                padding: "5px 25px",
                textTransform: "none",
                border: "none",
              }}
              className="btn_hover_effect"
            >
              Cancel
            </Button>
          </div>
          <div className="button-container" onClick={handleSave}>
            <Button
              size="large"
              block
              key="back"
              style={{
                color: "#244DA0",
                fontWeight: "600",
                padding: "5px 25px",
                textTransform: "none",
                border: "none",
              }}
              className="btn_hover_effect"
            >
              Save
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      {/* Update Event Modal */}
      <Dialog
        id="Add_event_dialog"
        open={updateDialog}
        onClose={false}
        className="filter_model"
        sx={{
          "& .MuiInputBase-root, & .MuiInputLabel-root, & .MuiFormHelperText-root": {
            fontFamily: "Milliard, sans-serif",
          },
        }}
      >
        <DialogTitle id="dialog_title">
          Update Event
          {/* <span>
            <DeleteIcon
              style={{ color: "red", cursor: "pointer" }}
              onClick={handleConform}
            />
          </span> */}
        </DialogTitle>
        <Divider />
        <DialogContent
          sx={{ m: 1, width: 300, display: "flex", flexDirection: "column" }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            className="Add_event_dialog_date_picker"
          >
            <DatePicker
              // defaultValue={date ? dayjs(date) : null}
              fullWidth
              value={currentValue?.holiday_date ? dayjs(currentValue.holiday_date) : null}
              format="DD-MM-YYYY"
              onChange={(newDate) => {
                setCurrentValue({
                  ...currentValue,
                  holiday_date: newDate ? newDate.format("YYYY-MM-DD") : null,
                });
              }}
              slotProps={{
                textField: {
                  size: "small",
                  // sx: {
                  //   "& .MuiInputBase-root": {
                  //     height: 40, // same as FormControl size="small"
                  //   },
                  // },
                },
              }}
            // onChange={(e) => {
            //   setDate(e.format("YYYY-MM-DD"));
            // }}
            // error={errorText.dob}
            />
          </LocalizationProvider>
          <FormControl sx={{ marginTop: "10px" }} size="small">
            <InputLabel id="demo-multiple-name-label">Select Role</InputLabel>
            <Select
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              multiple
              fullWidth
              value={currentValue?.role}
              onChange={handleUpdateSelect}
              input={<OutlinedInput label="Select Role" />}
              MenuProps={MenuProps}
              style={{ marginBottom: "4px" }}
              error={helperTxtselect === "" ? false : true}
              renderValue={(selected) => {
                let match = roleData?.filter((x) => selected.indexOf(x.id) > -1);
                if (match) {
                  match = match.map((x) => x.value).join(", ");
                  return match;
                }
                return;
              }}
            >
              <MenuItem value="all" sx={{ fontFamily: "MilliardBook, sans-serif" }}>
                <Checkbox
                  checked={checkIsAllSelected}
                  indeterminate={
                    currentValue?.role?.length > 0 &&
                    currentValue?.role?.length < roleData?.length
                  }
                />
                Select All
              </MenuItem>

              {roleData &&
                roleData.map((role) => (
                  <MenuItem key={role.id} value={role.id} sx={{ fontFamily: "MilliardBook, sans-serif" }}>
                    <Checkbox
                      checked={currentValue?.role?.indexOf(role.id) > -1}
                    />
                    {/* <ListItemText primary={role.value} /> */}
                    {role.value}
                  </MenuItem>
                ))}
            </Select>
            <FormHelperText style={{ color: "#d32f2f" }}>
              {helperTxtselect}
            </FormHelperText>
            <TextField
              size="small"
              margin="dense"
              id="title"
              label="Add Title"
              type="text"
              fullWidth
              variant="outlined"
              error={helperTxt === "" ? false : true}
              helperText={helperTxt}
              value={currentValue.holiday_title}
              onChange={(e) => {
                setCurrentValue({
                  ...currentValue,
                  holiday_title: e.target.value,
                });
                if (e.target.value === "") {
                  setHelperTxt("Please input Title!");
                } else {
                  setHelperTxt("");
                }
                return true;
              }}
            />
          </FormControl>
        </DialogContent>
        <Divider />
        <DialogActions
          style={{ justifyContent: "space-around", margin: "0px" }}
        >
          <div className="button-container" onClick={cancelDialog}>
            <Button
              block
              size="large"
              style={{
                color: "red",
                fontWeight: "600",
                padding: "5px 25px",
                textTransform: "none",
                border: "none",
              }}
              className="btn_hover_effect"
            >
              Cancel
            </Button>
          </div>
          <div className="button-container" onClick={onSave}>
            <Button
              size="large"
              block
              key="back"
              style={{
                color: "#244DA0",
                fontWeight: "600",
                padding: "5px 25px",
                textTransform: "none",
                border: "none",
              }}
              className="btn_hover_effect"
            >
              Update
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      {
        showModal && (
          <Dialog open={showModal} onClose={false} width={500}>
            <DialogTitle id="dialog_title">Event</DialogTitle>
            <Divider />
            <DialogContent>
              <div>
                <Typography
                  className="typography_view"
                  style={{ width: "300px" }}
                >
                  <span style={{ fontWeight: "600" }}>Date :&nbsp;</span>
                  {showModalData?.date}
                </Typography>
                <Typography
                  className="typography_view"
                  style={{ width: "300px" }}
                >
                  <span style={{ fontWeight: "600" }}>Title :&nbsp;</span>
                  {showModalData?.title}
                </Typography>
              </div>
            </DialogContent>
            <DialogActions
              style={{
                marginBottom: "10px",
                justifyContent: "flex-end",
                display: "flex",
                marginRight: "20px",
              }}
            >
              <Button
                variant="contained"
                onClick={() => setShowModal(false)}
                style={{
                  padding: "0px 40px",
                  backgroundColor: "rgb(36,77,160)",
                  color: "white",
                  borderRadius: "8px",
                }}
                size="large"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )
      }

      {/* DELETE CONFORM MODEL */}
      <Dialog open={conformDialog}>
        <DialogContent>
          <center>
            <ErrorIcon style={{ fontSize: "50px" }} />
          </center>
          <p
            style={{
              fontWeight: "600",
              fontSize: "18px",
              textAlign: "center",
              marginTop: "15px",
              color: " rgba(0, 0, 0, 0.66)",
            }}
          >
            Are You Sure Want To Delete ?
          </p>
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "center", marginBottom: "10px" }}
        >
          <Button
            block
            size="large"
            key="submit"
            type="primary"
            onClick={handleConformClose}
            style={{
              backgroundColor: "#E20E0E",
              borderRadius: "6px",
              fontWeight: "500",
              borderColor: "#E20E0E",
              textTransform: "none",
              width: "120px",
              color: "white",
            }}
          >
            No
          </Button>
          <Button
            size="large"
            block
            key="back"
            id="btnDelete"
            onClick={() => deleteEvent()}
            style={{
              backgroundColor: "#244DA0",
              borderRadius: "6px",
              color: "white",
              fontWeight: "500",
              borderColor: "#244DA0",
              textTransform: "none",
              width: "120px",
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
};

export default Holidays;
